import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Headline from '@components/atoms/headline/headline';
import Image from '@components/atoms/image/image';
import Copy from '@components/atoms/copy/copy';

import { getColor, mq, px2rem } from '@stylesheets/tools';

import Card from './Card';

const StyledContentCard = styled(Card)`
  position: relative;

  h2 {
    font-size: ${px2rem('18px')};
    color: ${getColor('black')};

    ${mq('m')} {
      font-size: ${px2rem('24px')};
    }
  }

  p {
    margin: 0;
    width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4; /* number of lines to show */
    line-clamp: 4;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    text-overflow: ellipsis;

    ${mq('m')} {
      -webkit-line-clamp: 3;
      line-clamp: 3;
    }
  }
`;

const ImageWrapper = styled.div`
  display: grid;
  align-items: center;
  position: relative;
  width: 100%;
  background-size: cover;
  margin-bottom: 10px;
  overflow: hidden;
  background: ${getColor('berry')};
  aspect-ratio: 5 / 3;

  ${mq('m')} {
    aspect-ratio: 16 / 6;
  }

  &:after {
    position: absolute;
    top: -12px;
    right: -12px;
    width: 24px;
    height: 24px;
    background: ${getColor('white')};
    content: '';
    transform: rotate(45deg);

    ${mq('m')} {
      top: -10px;
      right: -10px;
      width: 20px;
      height: 20px;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    top: 0;
    position: absolute;
  }
`;

const ContentCard = ({ headline, copy, href, image }) => {
  return (
    <StyledContentCard href={href} target="_blank" rel="noopener noreferrer">
      <ImageWrapper>
        <Image {...image} lazy="default" />
      </ImageWrapper>

      <Headline>{headline}</Headline>
      {copy && <Copy small>{copy}</Copy>}
    </StyledContentCard>
  );
};

ContentCard.propTypes = {
  image: PropTypes.shape().isRequired,
  headline: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired
};

export default ContentCard;
